// @flow
import React, { Component } from "react";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

import { LoadingProgress } from "imagus-components";
import QuoteTableRow from "./QuoteTableRow";

type UpgradeQuoteTablePropsType = {
  baseTable: Array<Array<*>>,
  upgradeTabel: Array<Array<*>>,
  renewTabel: Array<Array<*>>,
  yearTabel: Array<Array<*>>,
  totalTabel: Array<Array<*>>,
  authorised_reseller: boolean,
  companyType: string,
  create_date: Date,
  tier_name?: string,
  productSheetName?: string,
  startDate: Date
};

class UpgradeQuoteTable extends Component<UpgradeQuoteTablePropsType, *> {
  getSectionTitle = (title: string | React$Element<*>): * => (
    <TableRow>
      <TableCell colSpan={this.props.companyType === "RESELLER" ? 6 : 7}>
        <Typography variant="h6" className="form-text">
          {title}
        </Typography>
      </TableCell>
    </TableRow>
  );

  render(): * {
    let baseTable = this.props.baseTable;
    let upgradeTabel = this.props.upgradeTabel;
    let renewTabel = this.props.renewTabel;
    let yearTabel = this.props.yearTabel;
    let totalTabel = this.props.totalTabel;

    const authorised_reseller = this.props.authorised_reseller;
    const isReseller = this.props.companyType === "RESELLER";

    if (
      !baseTable ||
      !upgradeTabel ||
      !renewTabel ||
      !yearTabel ||
      !totalTabel
    ) {
      return (
        <div className="app-panel-content panel-top-margin">
          <LoadingProgress />
        </div>
      );
    } else {
      if (isReseller) {
        baseTable.map((row: Array<*>) => {
          row.splice(4, 1);
        });
        upgradeTabel.map((row: Array<*>) => {
          row.splice(4, 1);
        });
        renewTabel.map((row: Array<*>) => {
          row.splice(4, 1);
        });
        yearTabel.map((row: Array<*>) => {
          row.splice(4, 1);
        });
        totalTabel.map((row: Array<*>) => {
          row.splice(4, 1);
        });
      }

      return (
        <Paper style={{ padding: "10px 0" }}>
          <div style={{ height: "100%" }}>
            <Typography variant="h5" className="form-text">
              PRODUCT PRICE LIST - Imagus Pricing Schedule For{" "}
              {authorised_reseller ? "Authorised" : "Standard"} Resellers ONLY
            </Typography>
            <Typography variant="subtitle1" className="form-text form-hint">
              *All pricing excludes GST and this Price List must be distributed
              by the terms and conditions of your Distributor Agreement and NDA.
            </Typography>
            <Typography
              variant="subtitle1"
              className="form-text form-hint bottom-margin-15"
            >
              *This quote is generated on{" "}
              {moment.utc(this.props.create_date).local().format("DD/MMM/YYYY")}
              , all prices would only valid for <b>30</b> days.
            </Typography>
          </div>

          <Table className="app-table green center">
            <TableHead>
              <TableRow className="active">
                <TableCell className="blue-shine" width="140">
                  Part No.
                </TableCell>
                <TableCell className="blue-shine">Description</TableCell>
                <TableCell className="blue-shine" style={{ width: 225 }}>
                  Qty
                </TableCell>
                <TableCell className="blue-shine">Retail Price(AUD)</TableCell>
                {!isReseller && (
                  <TableCell className="blue-shine">
                    Distributor Price(AUD)
                  </TableCell>
                )}
                <TableCell className="blue-shine">
                  Reseller Price(AUD)
                </TableCell>
                <TableCell className="blue-shine">Notes</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={isReseller ? 6 : 7}
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    lineHeight: "24px"
                  }}
                >
                  {authorised_reseller ? (
                    <span>Imagus Authorised Upgrade Pricing</span>
                  ) : (
                    <span>Imagus Standard Upgrade Pricing</span>
                  )}

                  <span className="green-label left-margin-5">
                    (with 1 year maintenance)
                  </span>
                  {this.props.tier_name && (
                    <span
                      style={{ fontStyle: "italic" }}
                      className="left-margin-5"
                    >
                      ({this.props.tier_name})
                    </span>
                  )}
                  {this.props.productSheetName && (
                    <span
                      style={{ fontStyle: "italic" }}
                      className="left-margin-5"
                    >
                      ({this.props.productSheetName})
                    </span>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.getSectionTitle(
                <span>
                  Existing Software Licence for Upgrade{" "}
                  <span style={{ color: "#FF5630", fontSize: "80%" }}>
                    (Use for renewal fee calculation ONLY)
                  </span>
                </span>
              )}
              {baseTable.map((row: Array<*>, i: number): * => (
                <QuoteTableRow key={"base-" + i} row={row} isLight />
              ))}

              {this.getSectionTitle(
                "New Software Licence (Starts on " +
                  moment
                    .utc(this.props.startDate)
                    .local()
                    .format("DD/MMM/YYYY") +
                  ")"
              )}
              {upgradeTabel.map((row: Array<*>, i: number): * => (
                <QuoteTableRow key={"upgrade-" + i} row={row} />
              ))}

              {renewTabel.map((row: Array<*>, i: number): * => (
                <QuoteTableRow key={"renew-" + i} row={row} />
              ))}

              {this.getSectionTitle("Additional Maintenance")}
              {yearTabel.map((row: Array<*>, i: number): * => (
                <QuoteTableRow key={"year-" + i} row={row} />
              ))}

              {this.getSectionTitle("")}
              {totalTabel.map((row: Array<*>, i: number): * => (
                <QuoteTableRow key={"total-" + i} row={row} isBorder />
              ))}
            </TableBody>
          </Table>
        </Paper>
      );
    }
  }
}

export default UpgradeQuoteTable;
